/* eslint-disable @typescript-eslint/no-var-requires */

let logger;

if (typeof window === 'undefined') {
  const { createLogger, format, transports } = require('winston');

  const _logger = createLogger({
    format: format.json(),
    transports: [new transports.Console({ handleExceptions: true })],
  });

  logger = {
    log: (message, messageContext, status) => {
      _logger.log(status ?? 'info', message, messageContext);
    },
    debug: (tag, message, messageContext) =>
      _logger.debug(`[${tag}] ${message}`, messageContext),
    info: (message, messageContext) => _logger.info(message, messageContext),
    warn: (message, messageContext) => _logger.warn(message, messageContext),
    error: (message, messageContext) => _logger.error(message, messageContext),
  };
} else {
  const { faro, LogLevel } = require('@grafana/faro-web-sdk');

  const consoleMethods = { error: 'error', warn: 'warn' };

  // Ships browser logs to Loki via the Faro collector. Falls back to the
  // console when Faro is not initialized (e.g. local dev without FARO_URL).
  // faro.config is the initialization marker: faro.api is a noop stub
  // before initializeFaro runs, so it would swallow logs silently.
  const pushLog = (level, message, messageContext) => {
    if (faro.config) {
      faro.api.pushLog([message], {
        level,
        context: messageContext,
      });
    } else {
      // eslint-disable-next-line no-console
      console[consoleMethods[level] ?? 'log'](message, messageContext ?? '');
    }
  };

  logger = {
    log: (message, messageContext, status) =>
      pushLog(status ?? LogLevel.INFO, message, messageContext),
    debug: (tag, message, messageContext) =>
      pushLog(LogLevel.DEBUG, `[${tag}] ${message}`, messageContext),
    info: (message, messageContext) =>
      pushLog(LogLevel.INFO, message, messageContext),
    warn: (message, messageContext) =>
      pushLog(LogLevel.WARN, message, messageContext),
    error: (message, messageContext) =>
      pushLog(LogLevel.ERROR, message, messageContext),
  };
}

module.exports = logger;
